import * as yup from 'yup';

export const FIELD_IN_RU = 'ru';
export const FIELD_IN_UZ = 'uz';

export const FIELD_TITLE = 'title';
export const FIELD_REGION = 'region';
export const FIELD_CODE = 'code';

export const DistrictsEditValidationForm = yup.object().shape({
  [FIELD_TITLE]: yup.object().shape({
    [FIELD_IN_RU]: yup.string().required('error.required').trim(),
    [FIELD_IN_UZ]: yup.string().required('error.required').trim(),
  }),
  [FIELD_REGION]: yup.string().required('error.required').trim(),
  [FIELD_CODE]: yup.string().required('error.required').trim(),
});
